import ASSelect from 'react-select/async';

const ReactAsyncSelect = ({
    autoFocus = false,
    isClearable = true,
    isMulti = false,
    cacheOptions = false,
    placeholder = "Digite para pesquisar...",

    menuPlacement = 'bottom',

    isDisabled = false,

    defaultValue = "",
    value = null,

    onChange = () => { },
    loadOptions = () => { },
}) => {

    return (
        <ASSelect
            isMulti={isMulti}
            defaultOptions

            isDisabled={isDisabled}

            menuPlacement={menuPlacement}

            autoFocus={autoFocus}
            cacheOptions={cacheOptions}
            loadOptions={loadOptions}
            isClearable={isClearable}

            {...(value ? {
                "value": value,
            } : {})}

            defaultValue={defaultValue}

            noOptionsMessage={() => "Sem resultados"}
            loadingMessage={() => "Carregando ..."}
            placeholder={placeholder}

            onChange={onChange}

            styles={{
                control: (styles, state) => (
                    {
                        ...styles,
                        borderRadius: 2,
                        boxShadow: 'none',
                        borderColor: (!state.isFocused) ? '#ccc' : '#6c8fb1',

                        ':hover': {
                            borderColor: '#6c8fb1',
                        },

                        ':active': {
                            borderColor: '#6c8fb1',
                        },
                    }
                )
            }}
        />
    )
}

export default ReactAsyncSelect;